/**
 * @generated SignedSource<<93511fc3201afc47375b98e39318f62b>>
 * @relayHash 47a53ce07f81759a3971acda2cca0407
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-trade/538.0.0-2025-12-02T21:03:42.957Z/addPhotoLikeMutation

import { ConcreteRequest } from 'relay-runtime';
export type AddPhotoLikeMutationInput = {
  clientMutationId?: string | null;
  photoId: number;
  userId: string;
};
export type addPhotoLikeMutation$variables = {
  input: AddPhotoLikeMutationInput;
};
export type addPhotoLikeMutation$data = {
  readonly addPhotoLikeMutation: {
    readonly photoLikeId: string | null;
  } | null;
};
export type addPhotoLikeMutation = {
  response: addPhotoLikeMutation$data;
  variables: addPhotoLikeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddPhotoLikeMutationPayload",
    "kind": "LinkedField",
    "name": "addPhotoLikeMutation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "photoLikeId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addPhotoLikeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "addPhotoLikeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-trade/538.0.0-2025-12-02T21:03:42.957Z/addPhotoLikeMutation",
    "metadata": {},
    "name": "addPhotoLikeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b4421b2f0d032226141e6941d132ad94";

export default node;
